import { Button, ButtonGroup } from "@msuite/ui/button";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import type { Substitution } from "@msuite/utils/types";
import { SubstitutionPlanSummary } from "@/components/substitutions";

/** Props Interface */
interface SubstitutionPlanSummaryModalProps extends ModalProps {
	substitution: Substitution;
}

export function SubstitutionPlanSummaryModal({
	substitution,
	isOpen,
	onClose,
}: SubstitutionPlanSummaryModalProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Modal
			title={t("substitutions.summary")}
			isOpen={isOpen}
			onClose={onClose}
			width="60rem"
		>
			<Modal.Body>
				<SubstitutionPlanSummary absenceId={substitution.id} />
			</Modal.Body>
			<Modal.Footer>
				<ButtonGroup>
					<Button
						onClick={onClose}
						variant="primary"
					>
						{t("general.done")}
					</Button>
				</ButtonGroup>
			</Modal.Footer>
		</Modal>
	);
}
